export const PREVENTIF = {
    SET_ITEMS: 'SET_ITEMS_PREVENTIF',
    ADD_ITEMS: 'ADD_ITEMS_PREVENTIF',
    SET_DISPLAY: 'SET_DISPLAY_PREVENTIF',
    FILTER_BY_SITE: 'FILTER_BY_SITE_PREVENTIF',
    ADD_BEFORE: 'ADD_BEFORE_PREVENTIF',
    ADD_AFTER: 'ADD_AFTER_PREVENTIF',
    SET_HEADER: 'SET_HEADER_PREVENTIF',
    SET_PAGE: 'SET_PAGE_PREVENTIF',

    SET_FILTER: 'SET_FILTER_PREVENTIF',
    SWITCH_PREVISIONNEL_REEL: 'SWITCH_PREVISIONNEL_REEL_PREVENTIF',
    SWITCH_PERIODICITE: 'SWITCH_PERIODICITE_PREVENTIF',

    SET_LOADING: 'SET_LOADING_PREVENTIF',
    SET_LOADING_XLS_PREVENTIF: 'SET_LOADING_XLS_PREVENTIF',
    SET_ERROR: 'SET_ERROR_PREVENTIF',

    RESET: 'RESET_PREVENTIF',
    IS_ALL_DATA: 'IS_ALL_DATA',
    SET_LAST_SITE_ID: 'SET_LAST_SITE_ID',
    SET_IS_UNIQUE_SITE: 'SET_IS_UNIQUE_SITE'
};
